'use client';

import { Link } from 'solito/link';
import { Text, YStack } from '@ninjacart/nc-nk-ui';
import { QuestionAnswerLayout } from './qnaList';

export function QnaLandingView() {
    return (
        <>
            <YStack>
                <Text display="none">
                    {'Ninja Kisan Q&A | Ask Questions & Get Expert Farming Advice'}
                </Text>
                <YStack marginVertical={16} alignItems="center">
                    <Link href="/all-qna">
                        <Text
                            color="#0070f3"
                            textDecorationLine="underline"
                            fontWeight="600"
                        >
                            Browse the full Q&A archive
                        </Text>
                    </Link>
                </YStack>
            </YStack>

            <QuestionAnswerLayout />
        </>
    );
}
